import { Button, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AddCircle from '@mui/icons-material/AddCircle';
import { useTranslation } from 'react-i18next';
import STRING_KEYS from '../../../../../language/keys';
import { GET_COMPANIES_FROM } from '../../../../../consts';
import { style } from './style';

type NoCompaniesProps = {
    companiesGetFrom: string,
    onOpenCreateNewCompanyModal?: () => void,
    listAutocomplete:Company[],
    valueName: string,
}

export const NoCompanies = ({
  companiesGetFrom,
  onOpenCreateNewCompanyModal,
  listAutocomplete,
  valueName,
}: NoCompaniesProps): JSX.Element => {
  const { t: translate } = useTranslation();

  const defineNoOptions = () => {
    if (valueName.trim() !== '' &&
       companiesGetFrom !== '' &&
       listAutocomplete?.length === 0) {
      return (
        <div style={ style.noOptions }>
          <ErrorOutlineIcon />
          <Typography style={ style.noOptionsText }>
            {companiesGetFrom === GET_COMPANIES_FROM.LINKEDIN ?
              translate(STRING_KEYS.COMPANY_NOT_FOUND_LINKEDIN) :
              translate(STRING_KEYS.ADD_COMPANY_TO_DB, {
                companyName: valueName,
              })}
          </Typography>
          {companiesGetFrom === GET_COMPANIES_FROM.DB && (
            <Button
              size="large"
              style={ style.noOptionsButton }
              startIcon={ <AddCircle color="primary" /> }
              onClick={ () => onOpenCreateNewCompanyModal && onOpenCreateNewCompanyModal() }
            >{translate(STRING_KEYS.ADD_MANUALLY)}
            </Button>
          )}
        </div>
      );
    }
    
    return <>{translate(STRING_KEYS.NO_OPTIONS_PLACEHOLDER)}</>;
  };

  return defineNoOptions();
};
